import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { formatDateYYYYMMDD } from '../formatters';
import Request from './Request';
export class ClearScripts extends Request {
  constructor({
    url,
    keycloak,
    agency: _agency
  }) {
    super({
      url,
      keycloak
    });

    _defineProperty(this, "keycloak", void 0);

    _defineProperty(this, "commonHeaders", {
      Authorization: '',
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });

    _defineProperty(this, "getExternalUrl", async patientnumber => {
      const response = await this.get({
        api: `/clearscripts/thirdpartyurl`,
        qs: {
          patientnumber,
          action: 'update'
        }
      });
      return response;
    });

    _defineProperty(this, "getRxExternalUrl", async (site, agency, action) => {
      const response = await this.get({
        api: `clearscripts/thirdpartyurl/site/${site}`,
        qs: {
          action,
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getMeds", async patientNumber => {
      const response = await this.get({
        api: `/clearscripts/medicationcards/patient/${patientNumber}`
      });
      return response;
    });

    _defineProperty(this, "getMedsAndPrescriptions", async patientNumber => {
      const response = await this.get({
        api: `/clearscripts/medicationandprescriptioncards/patient/${patientNumber}`
      });
      return response;
    });

    _defineProperty(this, "getMedsWithRange", async (patientNumber, agency, fromdate, todate, type) => {
      const today = formatDateYYYYMMDD(new Date());
      const response = await this.get({
        api: `/clearscripts/medicationandprescriptioncards/v2/patient/${patientNumber}`,
        qs: {
          agency,
          fromdate: fromdate || today,
          todate: todate || today,
          type
        }
      });
      return response;
    });

    _defineProperty(this, "getUnreconciledMedsByPatientSince", async (fromdate, patientNumber) => {
      const response = await this.get({
        api: `/clearscripts/unreconciledmedicationcards/patient/${patientNumber}`,
        qs: {
          fromdate,
          patientNumber
        }
      }).then(res => {
        let finalResponse; // TODO this check can be refactored once the clearscript server goes live.

        if (res.status && res.status !== '200') {
          finalResponse = this.getMeds(patientNumber).then(newRes => newRes);
        } else {
          finalResponse = res;
        }

        return finalResponse;
      });
      return response;
    });

    _defineProperty(this, "getMedsSionce", async patientNumber => {
      const response = await this.get({
        api: `/clearscripts/medicationcards/patient/${patientNumber}`
      });
      return response;
    });

    _defineProperty(this, "updateAllMeds", async (fromdate, agency, patientnumber) => {
      const queryStringParams = {
        fromdate,
        agency,
        patientnumber
      };
      const response = await this.post({
        api: `/clearscripts/medications/syncFromProvider`,
        qs: queryStringParams
      });
      return response;
    });

    _defineProperty(this, "updateMaintStatus", async (patientNumber, status, orderType) => {
      const queryStringParams = orderType ? {
        status,
        ordertype: orderType
      } : {
        status
      };
      const response = await this.post({
        api: `/clearscripts/maintstatus/patient/${patientNumber}`,
        qs: queryStringParams
      });
      return response;
    });

    _defineProperty(this, "updateNotesMaintStatus", async (patientNumber, payload) => {
      const response = await this.post({
        api: `/clearscripts/maintstatus/v2/patient/${patientNumber}`,
        data: payload
      });
      return response;
    });

    _defineProperty(this, "updateNotesMaintStatusv3", async (patientNumber, payload, agency) => {
      const response = await this.post({
        api: `/clearscripts/maintstatus/v3/patient/${patientNumber}`,
        data: payload,
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "deletePatientDataSyncUser", async (id, agency) => {
      const response = await this.delete({
        api: `/clearscripts/deletepdsu/id/${id}`,
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "putMed", async med => {
      const response = await this.post({
        api: `/clearscripts/medicationcard`,
        data: med,
        method: 'PUT'
      });
      return response;
    });

    _defineProperty(this, "putMeds", async med => {
      const response = await this.post({
        api: `/clearscripts/medicationcards`,
        data: med,
        method: 'PUT'
      });
      return response;
    });

    _defineProperty(this, "syncMeds", async patientNumber => {
      const response = await this.post({
        api: `/clearscripts/syncdata/patient/${patientNumber}`
      });
      return response;
    });

    _defineProperty(this, "approveMeds", async (patientNumber, source) => {
      const response = await this.post({
        api: `/clearscripts/approvals/patient/${patientNumber}`,
        qs: {
          source
        }
      });
      return response;
    });

    _defineProperty(this, "getNotifications", async site => {
      const response = await this.get({
        api: `/clearscripts/notificationcounts`,
        qs: {
          site
        }
      });
      return response;
    });

    _defineProperty(this, "getUnreconciledMeds", async orderingphysicianid => {
      const response = await this.get({
        api: `/clearscripts/patients/unreconciledmeds`,
        qs: {
          orderingphysicianid
        }
      });
      return response;
    });

    _defineProperty(this, "getUnreconciledMedCounts", async (agency, fromdate, orderingphysicianid, siteid) => {
      const response = await this.get({
        api: `/clearscripts/patients/unreconciledmeds/v3`,
        qs: {
          agency,
          orderingphysicianid,
          fromdate,
          siteid
        }
      }).then(res => {
        let finalResponse; // TODO this check can be refactored once the clearscript server goes live.

        if (res && res.status && res.status !== '200') {
          finalResponse = this.get({
            api: `/clearscripts/patients/unreconciledmeds/v2`,
            qs: {
              orderingphysicianid,
              fromdate
            }
          }).then(newRes => newRes);
        } else {
          finalResponse = res;
        }

        return finalResponse;
      });
      return response;
    });

    _defineProperty(this, "getMedicationCards", async site => {
      const response = await this.get({
        api: `/clearscripts/medicationcards`,
        qs: {
          site
        }
      });
      return response;
    });

    _defineProperty(this, "getRcopia", async site => {
      const response = await this.get({
        api: `/clearscripts/siteconfigprovider/site/${site}`
      });
      return response;
    });

    this.url = new URL(url);
    this.keycloak = keycloak;

    if (_agency) {
      this.baseParams = {
        agency: _agency
      };
    }

    Object.defineProperty(this.commonHeaders, 'Authorization', {
      get() {
        const {
          token
        } = keycloak;
        return `Bearer ${token}`;
      },

      set(newValue) {// need a setter
      }

    });
    this.commonHeaders.Authorization = `Bearer ${keycloak.token}`;
  }

}
export default ClearScripts;